(() => {
  const reducedMotion = matchMedia('(prefers-reduced-motion: reduce)').matches;
  const root = document.documentElement;
  root.classList.toggle('wr-reduced-motion', reducedMotion);
  root.classList.add('wr-collection-cinematic-ready');

  document.querySelectorAll('.wr-collection-page').forEach((page) => {
    const results = page.querySelector('[data-collection-results]');
    if (!results || reducedMotion) return;
    let frame = 0;

    const update = () => {
      frame = 0;
      const distance = Math.max(260, Math.min(innerHeight * .72, 620));
      const progress = Math.min(1, Math.max(0, (scrollY / distance) * 1.35));
      results.style.setProperty('--collection-reveal-progress', progress.toFixed(4));
    };

    const requestUpdate = () => {
      if (!frame) frame = requestAnimationFrame(update);
    };

    update();
    addEventListener('scroll', requestUpdate, { passive: true });
    addEventListener('resize', requestUpdate, { passive: true });
  });
})();
